// Application constants
export const APP_CONFIG = {
  APP_ID: "2ltemb28s0osahwv8gr6cmm7zlvvacgf7bxfy77fwri1o88rds",
  VENUE_NAME: "Sarino's",
  SHOW_LOGO: false,
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
  APP_ENV: process.env.REACT_APP_ENV,
};

// Voice/Language constants
export const VOICE_CONFIG = {
  DEFAULT_REGION: "au",
  API_KEY: process.env.REACT_APP_MS_COGNITIVE_API_KEY,
  REGION: process.env.REACT_APP_MS_COGNITIVE_REGION,
};

// Fixed language list for test environments
export const FIXED_LANGUAGES = [
  {
    value: "MiueK1FXuZTCItgbQwPu",
    label: "Maya (AU)",
    region: "au",
  },
  {
    value: "ys3XeJJA4ArWMhRpcX1D",
    label: "Jess (AU)",
    region: "au",
  },
  {
    value: "M7ya1YbaeFaPXljg9BpK",
    label: "Hannah (AU)",
    region: "au",
  },
  {
    value: "sx8pHRzXdQfuUYPGFK7X",
    label: "Anna (AU)",
    region: "au",
  },
  {
    value: "kmgHxbD6paT09Ergj3XM",
    label: "Aiden (AU)",
    region: "au",
  },
  {
    value: "tWGXkYJGea4wMBN4mLD1",
    label: "CS New (AU)",
    region: "au",
  },
  {
    value: "kdmDKE6EkgrWrrykO9Qt",
    label: "Alexandra (US)",
    region: "us",
  },
  {
    value: "09AoN6tYyW3VSTQqCo7C",
    label: "Jessi (US)",
    region: "all",
  },
  {
    value: "other",
    label: "Other languages coming soon",
    region: "all",
    disabled: true,
  },
];

// Fake messages for different scenarios
export const FAKE_MESSAGES = {
  GetRecommendation: {
    "ar-IQ": "عظيم! دعني أتحقق من إمكانية الحجز لك، أعطني لحظة من فضلك.",
    "fr-FR": "Parfait ! Laissez-moi vérifier la disponibilité pour vous, veuillez patienter un instant.",
    "vi-VN": "Tốt lắm! Để tôi kiểm tra xem còn phòng không nhé, xin chờ một chút.",
    "hi-IN": "बहुत बढ़िया! मैं आपके लिए उपलब्धता जांचता हूँ, कृपया एक पल रुकें।",
    "ta-IN": "அருமை! உங்களுக்கான இடம் உள்ளதா என பார்க்கிறேன், தயவு செய்து ஒரு நிமிடம் காத்திருங்கள்.",
    "it-IT": "Ottimo! Controllo la disponibilità per te, ti prego di darmi un momento.",
    "zh-CN": "好的！我现在就为您查看是否有空位，请稍等一下。",
    "en-US": "Great! Let me check the availability for you, please give me a moment.",
  },
  Complete: {
    "ar-IQ": "شكراً لصبركم، لا زلت أعمل على حجزكم. الرجاء الانتظار للحظة.",
    "fr-FR": "Merci pour votre patience, je travaille toujours sur votre réservation. Veuillez patienter un moment.",
    "vi-VN": "Cảm ơn bạn đã kiên nhẫn, tôi vẫn đang làm việc trên đơn đặt chỗ của bạn. Xin hãy chờ một lúc.",
    "hi-IN": "आपके धैर्य के लिए धन्यवाद, मैं अभी भी आपकी बुकिंग पर काम कर रहा हूँ। कृपया एक पल रुकें।",
    "ta-IN": "உங்கள் பொறுமைக்கு நன்றி, நான் இன்னும் உங்கள் முன்பதிவில் வேலை செய்து கொண்டிருக்கிறேன். தயவு செய்து ஒரு நிமிடம் காத்திருங்கள்.",
    "it-IT": "Grazie per la pazienza, sto ancora lavorando alla tua prenotazione. Ti prego di aspettare un momento.",
    "zh-CN": "感谢您的耐心，我仍在处理您的预订。请稍等片刻。",
    "en-US": "Thank you for your patience, I'm still working on your booking. Please wait a moment.",
  },
};

export const FAKE_MESSAGES_RPA = {
  GetRecommendation: {
    "en-US": "Great! Let me check the availability for you, please give me a moment.",
  },
};
